import React, { useState } from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import { Text } from 'rebass'
import Modal from '../../../components/Modal';
import { ButtonConfirmed } from '../../../components/Button'
import { getBalanceNumber } from '../../../utils/bakery/formatBalance'
import Value from '../../../components/Value'

const TitleText = styled(Text)`
  font-family: Baloo Da;
  color: ${({ theme }) => theme.bsText7};
  text-align: center;
`
const InfoBox = styled.div`
  margin-top: 10px;
  margin-bottom: 35px;
`
const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.bsText7};
`
const TextTips = styled(Text)`
  color: #AC562B;
  text-align: center;
  line-height: 16px;
`
const ConfirmBtn = styled(ButtonConfirmed)`
  width: 100%;
  height: 40px;
  margin: 0 auto;
  font-size: 14px;
  /* overflow: hidden; */
`

const SModalWrapper = styled.div`
  padding: 24px 18px;
  max-width: 248px;
  background-color: ${({ theme }) => theme.bsBg1};
`;

interface HarvestModalProps {
  // ethNum: BigNumber
  tokenNum: BigNumber
  tokenName: string
  bakeNum: BigNumber
  onConfirm: (name: any) => Promise<string>
  // ModalProps
  isOpen: boolean
  onDismiss: () => void
  minHeight?: number | false
  maxHeight?: number
  maxWidth?: number
  initialFocusRef?: React.RefObject<any>
  children?: React.ReactNode
}

const HarvestModal: React.FC<HarvestModalProps> = ({
  // ethNum,
  tokenNum,
  tokenName,
  bakeNum,
  onConfirm,
  onDismiss,
  isOpen,
}) => {
  const [pendingTx, setPendingTx] = useState(false)
  const handleOnFirm = async () => {
      setPendingTx(true)
      const name = tokenName.toLowerCase()
      onConfirm(name)
        .then(() => {
          onDismiss && onDismiss()
        })
        .finally(()=>{
          setPendingTx(false)
        })
  }

  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss} maxWidth={248}>
      <SModalWrapper>
        <TitleText fontSize={20}>Harvest</TitleText>
        <TextTips fontSize={12}>The insufficient part of eth will be converted into equivalent bake</TextTips>
        <InfoBox>
          <InfoRow>
            <TitleText fontSize={14}>{tokenName}:</TitleText>
            <TitleText fontSize={20}>
              <Value value={getBalanceNumber(tokenNum)} />
            </TitleText>
          </InfoRow>
          <InfoRow>
            <TitleText fontSize={14}>BAKE:</TitleText>
            <TitleText fontSize={20}>
              <Value value={getBalanceNumber(bakeNum)} />
            </TitleText>
          </InfoRow>
        </InfoBox>
        <ConfirmBtn disabled={pendingTx} onClick={handleOnFirm}>{pendingTx ? 'Pending Confirmation' : 'Confirm'}</ConfirmBtn>
      </SModalWrapper>
    </Modal>
  )
}

export default HarvestModal
